<template>
  <transition name="fade" enter-active-class="afdc-animated afdc-animated-fast afdc-slideInLeft" leave-active-class="afdc-animated afdc-animated-fast afdc-slideOutLeft" v-on:after-enter="afterEnter">
    <div id="afdc-alt-fuel-station" tabindex="0">
      <div id="afdc-close-station" class="afdc-float-right" v-on:click="close">
        <span class="afdc-sr-only">{{ $t('Close') }}</span>
        <font-awesome-icon icon="times-circle" class="afdc-fa-icon"/>
      </div>

      <div v-if="$store.getters.getLoadingStationDetails" id="afdc-station-spinner-container">
        <div id="afdc-station-spinner"></div>
      </div>

      <h2>{{ $t('Report a Change') }}</h2>

      <p>{{ $t('Use this form to suggest updates for the station.') }} <span v-html="$sprintf($t('If you have more than one station to add or update, contact the <a href=\'%s\'>Technical Response Service</a> for a spreadsheet.'), 'mailto:technicalresponse@icf.com?subject=Station Update Spreadsheet')"></span></p>

      <station-form/>
    </div>
  </transition>
</template>

<script>
import StationForm from '@/components/StationForm.vue';

export default {
  components: {
    StationForm,
  },

  watch: {
    $route: {
      immediate: true,
      handler: 'fetchData',
    },
  },

  methods: {
    afterEnter() {
      this.focusOnLoad();
    },

    fetchData() {
      if (this.$route.name === 'StationEdit') {
        this.$store.dispatch('fetchStationDetails', this.$route.params.id);
      }
    },

    focusOnLoad() {
      if (this.$el) {
        this.$el.focus();
      }
    },

    close() {
      // To close the stations view, navigate back to the previously active
      // route (if one exists), taking into account any existing filters (so
      // their current search is retained).
      this.$router.push({
        name: this.$store.getters.getNavActiveFilterRouteName,
        query: this.$store.getters.getFilters,
      });
    },
  },
};
</script>

<style lang="scss">
</style>
